export function SearchDataSvg() {
    return {
        restrict: 'E',
        scope: true,
        template: `<ng-include class="d-contents" src="'../hui/modules/svg/search-data.svg'"></ng-include>`
    }
}
            